import { memo } from 'react'
import { Link } from 'react-router-dom'
import { useMentorsState } from '../../hooks/storeHooks/useMentors'
import { MentorBase } from '../../types/mentor'
import { analytics } from '../../utils/analytics'
import { CaseIcon } from '../Icons'

interface ISuggestedCompanionItemProps {
  companion: MentorBase
}

const SuggestedCompanionItem: React.FC<ISuggestedCompanionItemProps> = memo(
  ({ companion }) => {
    const { setSelectedMentor } = useMentorsState()

    const handleItemClick = () => {
      setSelectedMentor(companion)
      analytics.logEvent('aa_question_suggested_result_clicked')
    }

    return (
      <Link
        to={`/${companion.slug}?start=true`}
        state={{
          prevLocation: `${window.location.pathname}${window.location.search}`,
        }}
        onClick={handleItemClick}
      >
        <div className="flex gap-4 items-center p-2 tc-mv-blur">
          <div className="w-[72px] h-[72px] rounded-full overflow-hidden flex flex-grow-0 flex-shrink-0">
            <video
              src={companion.videoLoopUrl}
              poster={companion.previewUrl}
              muted
              autoPlay
              loop
              playsInline
              controlsList="nodownload"
              disablePictureInPicture
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex flex-col">
            <div className="font-bold text-white capitalize">
              {companion.firstName} {companion.lastName}
            </div>
            <div className="text-[#F5F5F5] text-sm">{companion.headline}</div>

            <div className="text-[#C1C1CA] text-sm flex gap-1 items-center">
              <CaseIcon size={16} /> {companion.jobTitle}
            </div>
          </div>
        </div>
      </Link>
    )
  },
)

export { SuggestedCompanionItem }
